// src/services/api/offlineSales/customers.js
import { apiClient } from '../base';

export const getCustomers = async (params = {}) => {
  const response = await apiClient.get('/offline-sales/customers', { params });
  return response.data;
};

export const getCustomer = async (customerId) => {
  const response = await apiClient.get(`/offline-sales/customers/${customerId}`);
  return response.data;
};

export const createCustomer = async (data) => {
  const response = await apiClient.post('/offline-sales/customers', data);
  return response.data;
};

export const updateCustomer = async (customerId, data) => {
  const response = await apiClient.put(`/offline-sales/customers/${customerId}`, data);
  return response.data;
};

export const getCustomerTypes = async () => {
  const response = await apiClient.get('/offline-sales/customer-types');
  return response.data;
};

export const getCustomerCategories = async () => {
  const response = await apiClient.get('/offline-sales/customer-categories');
  return response.data;
};

export const createCustomerCategory = async (data) => {
  const response = await apiClient.post('/offline-sales/customer-categories', data);
  return response.data;
};

export const getCustomerHistory = async (customerId, params = {}) => {
  const response = await apiClient.get(`/offline-sales/customers/${customerId}/history`, { params });
  return response.data;
};

export const importCustomers = async (rows) => {
  const response = await apiClient.post('/offline-sales/customers/import', { rows });
  return response.data;
};
